import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatCardModule} from '@angular/material/card';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatTableModule} from '@angular/material/table';
import {MatListModule} from '@angular/material/list';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

// Autosize

import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AutosizeModule} from 'ngx-autosize';

// Editor
 // import { NgxTinymceModule } from 'ngx-tinymce';

import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSortModule} from '@angular/material/sort';

import {MatPaginatorModule} from '@angular/material/paginator';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
//// FUSE
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseDemoModule } from '@fuse/components/demo/demo.module';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// RUTAS
import { routes } from './pagina.rutas';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// HERRAMIENTAS
import { ChatModule } from './tools/chat/chat.module';
import { TodoModule } from './tools/todo/todo.module';

// RESULTADOS
import { ResultdadosModule } from './resultados/resultados.module';


// COMPONENTES
import { ConfigComponent } from './configuracion/config.component';
import { UploadDBComponent } from './configuracion/uploaddb/uploaddb.component';
import { UploadLogoComponent } from './configuracion/uploadlogo/uploadlogo.component';
import { UploadFileComponent } from './configuracion/uploadfile/uploadfile.component';

import { GestUsuComponent } from './tools/gestUsu/gestUsu.component';
import { ODSComponent } from './tools/gestUsu/ods/ods.component';
import { EditComponent } from './tools/gestUsu/edit/edit.component';
import { TableODSComponent,AutologinDialog } from './tools/gestUsu/tableods/tableods.component';
// import { DetailComponent,DownloadDialog } from './tools/gestUsu/detail/detail.component';
// import { ControlEncuestasComponent } from './tools/gestUsu/detail/control-encuestas/control-encuestas.component';
import { RegisterUserComponent,DialogEditUsuarioEmpresa } from './tools/gestUsu/registeruser/registeruser.component';
import { CreateComponent } from './tools/templatescreate/create.component';

//import { IdiomasComponent } from './certificar/idiomas/idiomas.component';
import { GeneralinformationComponent } from './certificarN35/generalinformation/generalinformation.component';
import { BlogComponent } from './certificarN35/blog/blog.component';
import { DrawComponent } from './certificarN35/draw/draw.component';
import { WorkflowComponent } from './certificarN35/workflow/workflow.component';
import { SpaceconfigurationComponent } from './certificarN35/spaceconfiguration/spaceconfiguration.component';
//import { SecondmenuComponent } from './certificarN35/generalinformation/secondmenu/secondmenu.component';
import { EditN35Component } from './edit-n35/edit-n35.component';
import { Norm35Step8Component } from './certificarN35/norm35-step8/norm35-step8.component';
import { Norm35Step9Component } from './certificarN35/norm35-step9/norm35-step9.component';
import { Norm35Step10Component } from './certificarN35/norm35-step10/norm35-step10.component';
import { Norm35DocumentComponent } from './certificarN35/norm35-document/norm35-document.component';
import { Norm35ObjectComponent } from './certificarN35/norm35-object/norm35-object.component';
import { Norm35Step7Component } from './certificarN35/norm35-step7/norm35-step7.component';
import { TablesStepsComponent } from './certificarN35/draw/tables-steps/tables-steps.component';
import { Step10TablesComponent } from './certificarN35/norm35-step10/step10-tables/step10-tables.component';
import { Step9TablesComponent } from './certificarN35/norm35-step9/step9-tables/step9-tables.component';
import { Step7TableComponent } from './certificarN35/norm35-step7/step7-table/step7-table.component';
import { Step7DataComponent } from './certificarN35/norm35-step7/step7-data/step7-data.component';
import {Step6TableComponent} from '../pagina/certificarN35/workflow/step6-table/step6-table.component';
import { EditarNorm35Component} from '../pagina/certificarN35/editar-norm35/editar-norm35.component';
import { Step8DataComponent } from '../pagina/certificarN35/norm35-step8/step8-data/step8-data.component';
import { Step8TableComponent} from '../pagina/certificarN35/norm35-step8/step8-table/step8-table.component';
import { SecondnavbarComponent} from '../pagina/certificarN35/secondnavbar/secondnavbar.component';
import {Step5DataComponent} from '../pagina/certificarN35/draw/step5-data/step5-data.component';
//import {UploadsComponent} from '../pagina/certificarN35/uploads/uploads.component';
import {PoliticaComponent} from '../pagina/certificarN35/norm35-document/politica/politica.component';
import {ListComponent} from '../pagina/certificarN35/norm35-document/list/list.component';
import {AspectsComponent} from '../pagina/certificarN35/norm35-document/aspects/aspects.component';
import {TasklistComponent} from '../pagina/certificarN35/tasklist/tasklist.component';

import {Aspects2Component} from '../pagina/certificarN35/norm35-document/aspects2/aspects2.component';
import {DialogOverviewExampleDialog} from '../pagina/certificarN35/editar-norm35/editar-norm35.component';

import { RequirementsComponent } from './tools/requirements/requirements.component';
import { DetailRequirementsComponent } from './tools/detailrequirements/detailrequirements.component';
// import { DetailRequirementsComponent3 } from './tools/detailrequirements3.0/detailrequirements.component';

import { NoProductoComponent } from './landingPages/noProd/noProd.component';
import { CardedFullWidth2Component } from './carded/full-width-2.component';
import { Norm35DocumentTableComponent } from '../pagina/certificarN35/norm35-document/norm35-document-table/norm35-document-table.component';
import { from } from 'rxjs';
import { ReferenciaComponent } from './certificarN35/referencia/referencia.component';
import { ProjectDashboardComponent35 } from './encuestador-n35/cierre35/cierre35.component';
import { Colabs35Component } from './encuestador-n35/colabs35/colabs35.component';
import { Close35Component } from './encuestador-n35/close35/close35.component';
import { Guia1Component } from './certificarN35/norm35-document/guia1/guia1.component';
import { Dispatch35Component } from './encuestador-n35/dispatch35/dispatch35.component';
import { Formdialog35Component } from './encuestador-n35/dispatch35/formdialog35/formdialog35.component';
import { Alertdialog35Component } from './encuestador-n35/alertdialog35/alertdialog35.component';
//import { Demographictabs35Component } from './encuestador-n35/demographictabs35/demographictabs35.component';
//import { Adicionalesn35Component } from './encuestador-n35/adicionalesn35/adicionalesn35.component';
import { Encuestas35Component } from './encuestador-n35/encuestas35/encuestas35.component';
import { Enc2Component } from './encuestador-n35/encuestas35/enc2/enc2.component';
import { Enc3Component } from './encuestador-n35/encuestas35/enc3/enc3.component';
import { Shedulesurvey35Component } from './encuestador-n35/shedulesurvey35/shedulesurvey35.component';
import { Content35Component } from './encuestador-n35/shedulesurvey35/content35/content35.component';
import { Colaboradores35Component } from './encuestador-n35/colaboradores35/colaboradores35.component';
import { Guia4Component } from './certificarN35/norm35-document/guia4/guia4.component';
import { TaskfilesComponent } from './certificarN35/taskfiles/taskfiles.component';
//import { Formadialog35Component } from './encuestador-n35/shedulesurvey35/formadialog35/formadialog35.component';

import { CloudModule } from './tools/cloud/cloud.module';
import { UpdateEmployeesModule } from './tools/update-employees/update-employees.module';
import { AcercadeModule } from './tools/acercade/acercade.module';
import { GestorStatusModule } from './tools/gestUsu/gestor-status/gestor-status.module';
import { ReactivosModule } from './certificar/reactivos/reactivos.module';
import { AbiertasModule } from './certificar/abiertas/abiertas.module';
import { AbiertasFocusModule } from './FocusA/abiertas/abiertas.module';
import { ListaCTModule } from './certificarN35/lista-ct/lista-ct.module';
import { SurveyCheckModule } from './survey-check/survey.check.module';
import {ColaboradoresEncuestaModule} from './certificarN35/colaboradores-encuesta/colaboradores-encuesta.module';
import {PdfReporteModule} from './certificarN35/lista-ct/reporte/pdfreporte/pdfreporte.module';
import { ResultadosModule } from './certificarN35/resultados/resultados.module';
import { PortalConteosModule } from './portal-conteos/portal-conteos.module';
import { ReactivosFocusModule } from './FocusA/reactivos/reactivos.module';
import { GruposModule } from './FocusA/grupos/grupos.module';
import {ConsultarEnModule} from './tools/gestUsu/consultar-en/consultar-en.module';
import {ConsultarRequerimientosModule} from './tools/gestUsu/consultar-requerimientos/consultar-requerimientos.module';
import {AuditoriaAutoModule} from './tools/gestUsu/auditoria-auto/auditoria-auto.module';
import { ReqStepperModule } from './tools/req-stepper/req-stepper.module';
import { SurveyStatusModule } from './tools/survey-status/survey-status.module';
import { ReactivosMT1Module } from './productos/medir/tipo_1/reactivos/reactivos.module';
import { AbiertasMT1Module } from './productos/medir/tipo_1/abiertas/abiertas.module';
import { ReactivosMT2Module } from './productos/medir/tipo_2/reactivos/reactivos.module';
import { AbiertasMT2Module } from './productos/medir/tipo_2/abiertas/abiertas.module';
import { ReactivosMT3Module } from './productos/medir/tipo_3/reactivos/reactivos.module';
import { AbiertasMT3Module } from './productos/medir/tipo_3/abiertas/abiertas.module';
import { ReactivosMT4Module } from './productos/medir/tipo_4/reactivos/reactivos.module';
import { AbiertasMT4Module } from './productos/medir/tipo_4/abiertas/abiertas.module';

import { ReactivosMT5Module } from './productos/medir/tipo_5/reactivos/reactivos.module';
import { AbiertasMT5Module } from './productos/medir/tipo_5/abiertas/abiertas.module';
import { ReactivosMT6Module } from './productos/medir/tipo_6/reactivos/reactivos.module';
import { AbiertasMT6Module } from './productos/medir/tipo_6/abiertas/abiertas.module';


import { ReactivosCT1Module } from './productos/certificar/tipo_1/reactivos/reactivos.module';
import { AbiertasCT1Module } from './productos/certificar/tipo_1/abiertas/abiertas.module';
import { NpsModule } from './productos/certificar/tipo_1/nps/nps.module';
import { NpsModuleMedir1 } from './productos/medir/tipo_1/nps/nps.module';
import { NpsModuleMedir } from './productos/medir/tipo_6/nps/nps.module';
import { PaqueteModule } from './tools/gestUsu/paquete/paquete.module';
import { ControlModule } from './productos/certificar/tipo_1/control/control.module';
// import { VisorCorreosModule } from "./tools/gestUsu/detail/visor-correos/visor-correos.module";
import { MantenimientoModule } from "./tools/maintenance/mantenimiento.module";
import { ResetPasswordModule } from './tools/reset-password/reset-password.module';
import { LoginResetPasswordModule } from './tools/login-reset-password/login-reset-password.module';
import { Requerimientos3Module } from './tools/requerimientos3/requerimientos3.module';
import { ProfileModule } from './tools/profile/profile.module';
import { CloudODSModule } from './tools/cloudODS/cloud.module';
import { CultureauditModule } from "./productos/cultureaudit/cultureaudit.module";
import { ActiongoModule } from "./productos/actionGO/actiongo.module";
import { LandingModule } from "./landingProducto/landing.module";
import { LogoutModule } from "./landingPages/logout/logout.module";
import { HomeModule } from "./landingPages/home/home.module";
import { HomeV2Module } from "./landingPages/home-v2/home-v2.module";
import { DetailModule } from "./tools/gestUsu/detail/detail.module";
import { EditorBrokerModule } from "./tools/editor-broker/editor-broker.module";
import { SurveyStatusV2Module } from "./tools/survey-status-v2/survey-status-v2.module";
import { EmailHistoryTableModule } from "./tools/email-history-table/email-history-table.module";
import { PerfilUsuarioModule } from "./tools/perfil-usuario/perfil-usuario.module";
import { PruebasModule } from "./tools/01-pruebas/01-pruebas.module";
import { LogActualizacionesModule } from "./tools/log-actualizaciones/log-actualizaciones.module";
import { OdsV2Module } from "./tools/gestUsu/ods-v2/ods-v2.module";
import { KnowledgeBaseModule } from "app/main/pagina/productos/knowledge-base/knowledge-base.module";
import { ConfiguracionVozModule } from "app/main/pagina/productos/certificar/tipo_2/configuracion-voz/configuracion-voz.module";
import { ConsultaEncuestaModule } from "app/main/pagina/tools/consulta-encuesta/consulta-encuesta.module";
import { RawdataFinderModule } from "app/main/pagina/tools/rawdata-finder/rawdata-finder.module";

// import { GestorStatusComponent } from './tools/gestUsu/gestor-status/gestor-status.component';
import { ColaboradoresComponent } from './certificarN35/colaboradores/colaboradores.component';
import { ExpedienteModule } from '../pagina/certificarN35/expediente/expediente.module';
import { InformacionCtComponent } from './certificarN35/informacion-ct/informacion-ct.component';


import { AlertDialogComponent} from './FocusA/alertdialog/alertdialog.component';
import { FormDialogComponent } from './FocusA/dispatch/formdialog/form.component';
// import { ContentComponent } from './FocusA/shedulesurvey/content/content.component';
import { TablaComponent} from './resultados/trustindex/secciones/tabla/tabla.component';
import { CertificarComponent } from './resultados/trustindex/secciones/certificar/certificar.component';
import { MedirComponent } from './resultados/trustindex/secciones/medir/medir.component';
import { PulsecheckComponent } from './resultados/trustindex/secciones/pulse-check/pulse-check.component';
import { ExtensionPipe } from './resultados/trustindex/secciones/tabla/tabla.pipe';
import {MatToolbarModule} from '@angular/material/toolbar';
import { QuestionsComponent } from './tools/questions/questions.component';
import { Videos35Component } from './tools/videos35/videos35.component';
import { TimelineComponent } from './certificarN35/timeline/timeline.component';
import { VideosAdministradorComponent } from './tools/videos-administrador/videos-administrador.component';


// import { PdfMakeWrapper } from 'pdfmake-wrapper';
// import * as pdfFonts from "pdfmake/build/vfs_fonts"; // fonts provided for pdfmake

// import { PreviewEncuestasComponent } from './tools/gestUsu/detail/control-encuestas/preview-encuestas/preview-encuestas.component';
import { NormatipsComponent } from './tools/normatips/normatips.component';
import { LogSistemaComponent } from './tools/log-sistema/log-sistema.component';
import { SendgridLogComponent } from './tools/sendgrid-log/sendgrid-log.component';
import { DialogInfo } from './tools/sendgrid-log/sendgrid-log.component';
// import { EstatusEncuestaComponent } from './productos/certificar/tipo_1/estatus-encuesta/estatus-encuesta.component';
//import { V2SurveyStatusComponent } from './tools/v2-survey-status/v2-survey-status.component';

//import { ColaboradoresEncuestaComponent } from './certificarN35/colaboradores-encuesta/colaboradores-encuesta.component';

// Set the fonts to use
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { TemplateAdminComponent } from './productos/certificar/tipo_2/template-admin/template-admin.component';

import { HistoryProductModule } from './tools/history-product/history-product.module';
import { TablaEmailHistoryModule } from './tools/tabla-email-history/tabla-email-history.module';
import { SelectLeaderComponent } from './productos/leaderGo/select-leader/select-leader.component';
import { SelectActionLeaderComponent } from './productos/actionGo-v2/select-leader/select-leader.component';
import { EditTemplateEmailComponent } from './productos/leaderGo/edit-template-email/edit-template-email.component';
import { ConfirmaEnvioComponent } from './productos/leaderGo/confirma-envio/confirma-envio.component';
import { ConfirmaActionEnvioComponent } from './productos/actionGo-v2/confirma-envio/confirma-envio.component';
import { AvanceLeaderComponent } from './productos/leaderGo/avance-leader/avance-leader.component';
import { AvanceActionLeaderComponent } from './productos/actionGo-v2/avance-leader/avance-leader.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { TableLeaderGoComponent } from './productos/leaderGo/table-leader-go/table-leader-go.component';
import { ModalInfoComponent } from './productos/leaderGo/table-leader-go/modal-info/modal-info.component';
// PdfMakeWrapper.setFonts(pdfFonts);
import { FlexLayoutModule } from '@angular/flex-layout';
import { StylePaginatorDirective } from './productos/actionGo-v2/select-leader/style-paginator.directive';

import { WebCompProfileModule } from './web-comp-profile/web-comp-profile.module';
import {ControlEncuesModule} from 'app/main/pagina/tools/control-encues/control-encues.module';
import {ExterWebComProfileModule} from 'app/main/pagina/exter-web-com-profile/exter-web-com-profile.module';
import { CalendsurveyModule } from './tools/calendsurvey/calendsurvey.module';
import { SurveyGenericModule } from "app/main/pagina/tools/survey-generic/survey-generic.module";
import { TableodsV2Component,AutologinDialogV2 } from './tools/gestUsu/tableods-v2/tableods-v2.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ChartsModule } from 'ng2-charts';
@NgModule({
    declarations: [
        //BlankComponent,
        Step8DataComponent,
        Step8TableComponent,
        SecondnavbarComponent,

        Step5DataComponent,
        PoliticaComponent,
        ListComponent,
        AspectsComponent,
        Aspects2Component,
        TasklistComponent,
        DialogOverviewExampleDialog,
        CardedFullWidth2Component,
        ConfigComponent,
        UploadDBComponent,
        UploadLogoComponent,
        UploadFileComponent,
        GestUsuComponent,
        RequirementsComponent,
        DetailRequirementsComponent,
        ODSComponent,
        EditComponent,
        CreateComponent,
        // DetailComponent,
        // DownloadDialog,
        TableODSComponent,
        AutologinDialog,
        AutologinDialogV2,
        RegisterUserComponent,
        //IdiomasComponent,
        GeneralinformationComponent,
        BlogComponent,
        DrawComponent,
        WorkflowComponent,
        SpaceconfigurationComponent,
        //SecondmenuComponent,
        EditN35Component,
        Norm35Step8Component,
        Norm35Step9Component,
        Norm35Step10Component,
        Norm35DocumentComponent,
        Norm35ObjectComponent,
        Norm35Step7Component,
        TablesStepsComponent,
        Step10TablesComponent,
        Step9TablesComponent,
        Step7TableComponent,
        Step7DataComponent,
        Step6TableComponent,
        EditarNorm35Component,
        Step8DataComponent,
        Step8TableComponent,
        SecondnavbarComponent,
        Step5DataComponent,
        Norm35DocumentTableComponent,
        // UploadsComponent,
        PoliticaComponent,
        ListComponent,
        AspectsComponent,
        TasklistComponent,
        Aspects2Component,
        DialogOverviewExampleDialog,

        //Norma1Component,
        //CloseComponent

        NoProductoComponent,

        ReferenciaComponent,

        ProjectDashboardComponent35,

        Colabs35Component,

        Close35Component,

        Guia1Component,

        Dispatch35Component,

        Formdialog35Component,

        Alertdialog35Component,



        //Adicionalesn35Component,

        Encuestas35Component,

        Enc2Component,

        Enc3Component,

        Shedulesurvey35Component,

        Content35Component,

        Colaboradores35Component,

        Guia4Component,

        TaskfilesComponent,

        // GestorStatusComponent,

        ColaboradoresComponent,

        InformacionCtComponent,


        //Formadialog35Component

        AlertDialogComponent,
        FormDialogComponent,
        // ContentComponent,
        TablaComponent,
        CertificarComponent,
        MedirComponent,
        PulsecheckComponent,
        ExtensionPipe,
        QuestionsComponent,
        Videos35Component,
        TimelineComponent,
        VideosAdministradorComponent,
        // ControlEncuestasComponent,
        // PreviewEncuestasComponent,
        NormatipsComponent,
        DialogEditUsuarioEmpresa,
        LogSistemaComponent,
        SendgridLogComponent,
        DialogInfo,
        TemplateAdminComponent,
        SelectLeaderComponent,
        SelectActionLeaderComponent,
        EditTemplateEmailComponent,
        ConfirmaEnvioComponent,
        ConfirmaActionEnvioComponent,
        AvanceLeaderComponent,
        AvanceActionLeaderComponent,
        TableLeaderGoComponent,
        ModalInfoComponent,
        StylePaginatorDirective,
        TableodsV2Component,
        // EstatusEncuestaComponent,
        //V2SurveyStatusComponent,
        //ColaboradoresEncuestaComponent,

    ],
    imports     : [
        routes,
        MatGridListModule,
        MatBadgeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule ,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatListModule,
        MatStepperModule,
        MatTabsModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatIconModule,
        MatCardModule,
        DragDropModule,
        MatRadioModule,
        MatTooltipModule,
        MatTreeModule,
        MatExpansionModule,
        MatBottomSheetModule,
        MatTableModule,
        /*NgxTinymceModule.forRoot({
            // baseURL: './assets/tinymce/',
            // or cdn
            baseURL: '//cdnjs.cloudflare.com/ajax/libs/tinymce/4.9.0/'
        }),*/
        MatDatepickerModule,
        BrowserAnimationsModule,
        MatRadioModule,
        MatDatepickerModule,
        MatSortModule,
        MatPaginatorModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,

        TranslateModule,
        ChatModule,
        TodoModule,
        ResultdadosModule,

        FuseSidebarModule,
        FuseSharedModule,
        FuseDemoModule,
        // Autosize
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AutosizeModule,
        CloudModule,
        UpdateEmployeesModule,
        AcercadeModule,
        ExpedienteModule,
        GestorStatusModule,
        MatToolbarModule,
        ReactivosModule,
        ReactivosFocusModule,
        AbiertasModule,
        AbiertasFocusModule,
        ListaCTModule,
        SurveyCheckModule,
        ColaboradoresEncuestaModule,
        PdfReporteModule,
        ResultadosModule,
        PortalConteosModule,
        GruposModule,
        ConsultarEnModule,
        ConsultarRequerimientosModule,
        ReactivosMT1Module,
        ReactivosMT2Module,
        ReactivosMT3Module,
        ReactivosMT4Module,
        ReactivosMT5Module,
        ReactivosMT6Module,
        AbiertasMT1Module,
        AbiertasMT2Module,
        AbiertasMT3Module,
        AbiertasMT4Module,
        AbiertasMT5Module,
        AbiertasMT6Module,
        ReqStepperModule,
        SurveyStatusModule,
        ReactivosCT1Module,
        AbiertasCT1Module,
        NpsModule,
        NpsModuleMedir,
        NpsModuleMedir1,
        ControlModule,
        PaqueteModule,
        AuditoriaAutoModule,
        MantenimientoModule,
        ResetPasswordModule,
        LoginResetPasswordModule,
        Requerimientos3Module,
        ProfileModule,
        // VisorCorreosModule,
        CloudODSModule,
        CultureauditModule,
        ActiongoModule,
        LandingModule,
        MatSlideToggleModule,
        LogoutModule,
        HomeModule,
        HomeV2Module,
        DetailModule,
        EditorBrokerModule,
        SurveyStatusV2Module,
        EmailHistoryTableModule,
        PerfilUsuarioModule,
        NgxMaterialTimepickerModule,
        HistoryProductModule,
        TablaEmailHistoryModule,
        MatSidenavModule,
        FlexLayoutModule,
        PruebasModule,
        LogActualizacionesModule,
        OdsV2Module,
        KnowledgeBaseModule,
        ConfiguracionVozModule,
        WebCompProfileModule,
        ConsultaEncuestaModule,
        ControlEncuesModule,
        ExterWebComProfileModule,
        CalendsurveyModule,
        SurveyGenericModule,
        RawdataFinderModule,
        NgCircleProgressModule.forRoot({}),
    ChartsModule,
    ],
    entryComponents:[
        DialogOverviewExampleDialog,
        // DownloadDialog,
        DialogEditUsuarioEmpresa,
        AutologinDialog,
        AutologinDialogV2,
        DialogInfo,
        ModalInfoComponent,
      ],

})
export class PaginaModule { }
